import { IncidentsList } from "./IncidentsList";

export default {
  title: "SecurityPortal/Incidents/IncidentsList",
  component: IncidentsList,
  decorators: [
    (Story) => (
      <div
        style={{
          background: "white",
          color: "black",
          padding: "20px",
          height: "300px",
        }}
      >
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => <IncidentsList {...args} />;

export const Example = Template.bind({});
Example.args = {
  incidents: [
    {
      pendingSuspension: {
        platforms: ["CommuniKate", "Events"],
        suspendUntil: "2223-07-08T02:45:21.850Z",
        reason: "Harrasment2",
        reminderDate: "2023-07-09T02:45:21.850Z",
      },
      startDate: {
        month: "February",
        day: 1,
        year: 2022,
      },
      complaintAgainst: {
        iboNumber: 6983642,
        email: "dreamstream+qa.6983642.1445048.5@wwdb.com",
        firstName: "JAMES",
        lastName: "ABADILLA",
        phoneNumber: "(702) 461-2597",
        address: "asdf",
        city: "wa",
        state: "wa",
        zipCode: "12312",
      },
      documentation: {
        evidence: [],
      },
      _id: "64a7892398d2360423c4aad4",
      primaryIboNumber: 752313,
      primaryEmail: "dreamstream+qa.752313.643746.17@wwdb.com",
      firstName: "GERRI",
      lastName: "DICKEY",
      phoneNumber: "(509) 123-4567",
      address: "8518 N WEIPERT DR",
      city: "SPOKANE",
      state: "WA",
      zipCode: "99208-5935",
      problemType: "Violence",
      problemLocation: "In Person",
      subLocation: "DreamStream",
      description: "asdf",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/fead4bc0-1c77-11ee-a09e-bb4edeac43c2.jpg",
          name: "GettyImages-1145794687 - Copy.jpg",
          downloadPath: "security-app/fead4bc0-1c77-11ee-a09e-bb4edeac43c2.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "No",
      recentActivity: [
        {
          date: "2023-07-08T02:45:22.088Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8cdc2dc55e7052403d119",
        },
        {
          date: "2023-07-08T02:44:18.771Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8cd8208e6a630dff65b50",
        },
        {
          date: "2023-07-08T02:43:38.916Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8cd5a0a8a795d3aedc775",
        },
        {
          date: "2023-07-08T02:43:33.107Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8cd55dc55e7052403d100",
        },
        {
          date: "2023-07-08T02:27:58.260Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a8c9ae0a8a795d3aedc761",
        },
        {
          date: "2023-07-07T04:46:36.141Z",
          message:
            "Suspended email sent to suspended user: dreamstream+qa.6983642.1445048.5@wwdb.com",
          _id: "64a798ac64bd9b2390aaefb0",
        },
      ],
      reminders: [],
      incidentNotes: [],
      events: [],
      historyOfActions: [
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:45:22.089Z",
          _id: "64a8cdc2dc55e7052403d11a",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:44:18.772Z",
          _id: "64a8cd8208e6a630dff65b51",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:43:38.917Z",
          _id: "64a8cd5a0a8a795d3aedc776",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:43:33.111Z",
          _id: "64a8cd55dc55e7052403d101",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-08T02:27:58.263Z",
          _id: "64a8c9ae0a8a795d3aedc762",
        },
        {
          text: "User has been suspended",
          createdAt: "2023-07-07T04:46:36.144Z",
          _id: "64a798ac64bd9b2390aaefb1",
        },
      ],
      createdAt: "2023-07-07T03:40:19.793Z",
      updatedAt: "2023-07-08T02:45:22.090Z",
      __v: 0,
      id: "64a7892398d2360423c4aad4",
    },
    {
      escalation: {
        reason: "sadf",
        actionsNeeded: "sadf",
        createdAt: "2023-07-07T02:40:55.752Z",
      },
      notes: {
        title: "Escalated - Investigation",
        body: "sadf - sadf",
        createdAt: "2023-07-07T02:40:55.752Z",
      },
      pendingSuspension: {
        platforms: [],
      },
      startDate: {
        month: "January",
        day: 1,
        year: 2021,
      },
      complaintAgainst: {
        iboNumber: 1478107,
        email: "dreamstream+qa.1478107.1463.5@wwdb.com",
        firstName: "RANDY",
        lastName: "JASSMAN",
        phoneNumber: "(509) 995-6003",
        address: "1717 PENINSULA RD",
        city: "HOPE",
        state: "ID",
        zipCode: "83836-9753",
      },
      documentation: {
        evidence: [],
      },
      _id: "64a775fc9066ab70a9f461ff",
      primaryIboNumber: 138306,
      primaryEmail: "notprovided@email.com",
      firstName: "TESS",
      lastName: "MILLER",
      phoneNumber: "(406) 580-5898",
      address: "681 CANDLELIGHT DR",
      city: "BOZEMAN",
      state: "MT",
      zipCode: "59718",
      problemType: "Hate Speech/Racism",
      problemLocation: "In Person",
      subLocation: "Communicate",
      description: "asdf",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/94228500-1c6c-11ee-a9ff-7b9387134cde.jpg",
          name: "GettyImages-1145794687.jpg",
          downloadPath: "security-app/94228500-1c6c-11ee-a9ff-7b9387134cde.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "Yes",
      recentActivity: [
        {
          date: "2023-07-07T05:00:13.138Z",
          message: "Caution Letter email sent to: notprovided@email.com",
          _id: "64a79bdd9066ab70a9f472b2",
        },
      ],
      reminders: [],
      incidentNotes: [
        {
          title: "123",
          text: "123",
          files: [
            {
              type: "image/jpeg",
              src: "https://wwgusdev.blob.core.windows.net/security-app/dda0d770-1c6e-11ee-bad0-35942e23f811.jpg",
              name: "GettyImages-1145794687 - Copy.jpg",
              downloadPath:
                "security-app/dda0d770-1c6e-11ee-bad0-35942e23f811.jpg",
            },
          ],
          createdAt: "2023-07-07T02:34:58.532Z",
          _id: "64a779d24a027297a275730a",
        },
        {
          title: "123",
          text: "123",
          files: [
            {
              type: "image/jpeg",
              src: "https://wwgusdev.blob.core.windows.net/security-app/16b476d0-1c6e-11ee-a09e-bb4edeac43c2.jpg",
              name: "GettyImages-1145794687 - Copy.jpg",
              downloadPath:
                "security-app/16b476d0-1c6e-11ee-a09e-bb4edeac43c2.jpg",
            },
          ],
          createdAt: "2023-07-07T02:29:24.793Z",
          _id: "64a7788598d2360423c4a1f2",
        },
        {
          title: "123",
          text: "123",
          files: [],
          createdAt: "2023-07-07T02:29:15.601Z",
          _id: "64a7787b4a027297a27571c6",
        },
      ],
      events: [],
      historyOfActions: [
        {
          text: "Escalated - Investigation",
          createdAt: "2023-07-07T02:40:55.752Z",
          _id: "64a77b3764bd9b2390aae4db",
        },
        {
          text: "Note added to case by TESS",
          createdAt: "2023-07-07T02:34:58.532Z",
          _id: "64a779d24a027297a275730b",
        },
        {
          text: "Note added to case by TESS",
          createdAt: "2023-07-07T02:29:24.793Z",
          _id: "64a7788598d2360423c4a1f3",
        },
        {
          text: "Note added to case by TESS",
          createdAt: "2023-07-07T02:29:15.601Z",
          _id: "64a7787b4a027297a27571c7",
        },
      ],
      createdAt: "2023-07-07T02:18:36.614Z",
      updatedAt: "2023-07-07T05:00:13.142Z",
      __v: 0,
      severity: "Level 2",
      caseOwner: "Diane",
      status: "Read",
      id: "64a775fc9066ab70a9f461ff",
    },
    {
      pendingSuspension: {
        platforms: [],
      },
      startDate: {
        month: "February",
        day: 3,
        year: 2022,
      },
      complaintAgainst: {
        iboNumber: 1478107,
        email: "dreamstream+qa.1478107.1463.5@wwdb.com",
        firstName: "RANDY",
        lastName: "JASSMAN",
        phoneNumber: "(509) 995-6003",
        address: "1717 PENINSULA RD",
        city: "HOPE",
        state: "ID",
        zipCode: "83836-9753",
      },
      documentation: {
        evidence: [],
      },
      _id: "64a7748b494fc8a2dd5f48c8",
      primaryIboNumber: 6996617,
      primaryEmail: "dreamstream+qa.6996617.1446364.5@wwdb.com",
      firstName: "HEATHER",
      lastName: "ADAM",
      phoneNumber: "(403) 771-0026",
      address: "21 BERKELEY PL W 322",
      city: "LETHBRIDGE",
      state: "AB",
      zipCode: "T1K5N1",
      problemType: "Hate Speech/Racism",
      problemLocation: "Online Platform",
      subLocation: "DreamStream",
      description: "sadf",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/b85a2d20-1c6b-11ee-85f8-c7f063076001.jpg",
          name: "GettyImages-1145794687.jpg",
          downloadPath: "security-app/b85a2d20-1c6b-11ee-85f8-c7f063076001.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "Yes",
      recentActivity: [],
      reminders: [],
      incidentNotes: [],
      events: [],
      historyOfActions: [],
      createdAt: "2023-07-07T02:12:27.978Z",
      updatedAt: "2023-07-07T02:12:27.978Z",
      __v: 0,
      id: "64a7748b494fc8a2dd5f48c8",
    },
    {
      pendingSuspension: {
        platforms: [],
      },
      startDate: {
        month: "November",
        day: 3,
        year: 2021,
      },
      complaintAgainst: {
        iboNumber: 7789,
        email: "dreamstream+qa.7789.1247.5@wwdb.com",
        firstName: "BILL",
        lastName: "HAWKINS",
        phoneNumber: "(763) 242-5300",
        address: "4680 - 152ND CT NW",
        city: "RAMSEY",
        state: "MN",
        zipCode: "55303",
      },
      documentation: {
        evidence: [],
      },
      _id: "64a726a3ff5733c044522d1d",
      primaryIboNumber: 4745557,
      primaryEmail: "dreamstream+qa.4745557.770648.5@wwdb.com",
      firstName: "JOHN",
      lastName: "BAKER",
      phoneNumber: "(425) 334-1936",
      address: "123",
      city: "wa",
      state: "wa",
      zipCode: "12312",
      problemType: "Hate Speech/Racism",
      problemLocation: "Online Platform",
      subLocation: "DreamStream",
      description: "west",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/488a9ad0-1c3d-11ee-a1ca-a54a38ba42a7.jpg",
          name: "GettyImages-1145794687 - Copy.jpg",
          downloadPath: "security-app/488a9ad0-1c3d-11ee-a1ca-a54a38ba42a7.jpg",
        },
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/48c44870-1c3d-11ee-a1ca-a54a38ba42a7.jpg",
          name: "GettyImages-1145794687.jpg",
          downloadPath: "security-app/48c44870-1c3d-11ee-a1ca-a54a38ba42a7.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "Yes",
      recentActivity: [],
      reminders: [],
      incidentNotes: [],
      events: [],
      historyOfActions: [],
      createdAt: "2023-07-06T20:40:03.555Z",
      updatedAt: "2023-07-06T20:40:03.555Z",
      __v: 0,
      id: "64a726a3ff5733c044522d1d",
    },
    {
      escalation: {
        reason: "asfd",
        actionsNeeded: "asdf",
        createdAt: "2023-07-07T02:40:36.269Z",
      },
      notes: {
        title: "Escalated - Investigation",
        body: "asfd - asdf",
        createdAt: "2023-07-07T02:40:36.269Z",
      },
      pendingSuspension: {
        platforms: [],
      },
      startDate: {
        month: "January",
        day: 1,
        year: 2021,
      },
      complaintAgainst: {
        iboNumber: 1356957,
        email: "notprovided@email.com",
        firstName: "RANDY",
        lastName: "ALCOTT",
        phoneNumber: "(253) 265-2199",
        address: "dasf",
        city: "wa",
        state: "wa",
        zipCode: "12312",
      },
      documentation: {
        evidence: [],
        description: "fdafs test",
      },
      _id: "64a634676ae9d058de3df78c",
      primaryIboNumber: 1478107,
      primaryEmail: "dreamstream+qa.1478107.1463.5@wwdb.com",
      firstName: "RANDY",
      lastName: "JASSMAN",
      phoneNumber: "(509) 995-6003",
      address: "1717 PENINSULA RD",
      city: "HOPE",
      state: "ID",
      zipCode: "83836-9753",
      problemType: "Harassment",
      problemLocation: "In Person",
      subLocation: "DreamStream",
      description: "fdafs",
      evidence: [
        {
          type: "image/jpeg",
          src: "https://wwgusdev.blob.core.windows.net/security-app/e70f79a0-1bac-11ee-9a15-735bd5c45b7d.jpg",
          name: "GettyImages-1145794687.jpg",
          downloadPath: "security-app/e70f79a0-1bac-11ee-9a15-735bd5c45b7d.jpg",
        },
      ],
      isMember: "Yes",
      hasViolated: "Yes",
      fromUpline: "Yes",
      recentActivity: [
        {
          date: "2023-07-06T20:19:21.613Z",
          message:
            "Disciplinary Letter - Physical Therapist email sent to: dreamstream+qa.1478107.1463.5@wwdb.com",
          _id: "64a721c9c661131412823797",
        },
      ],
      reminders: [],
      incidentNotes: [
        {
          title: "123",
          text: "123",
          files: [],
          createdAt: "2023-07-07T02:35:57.785Z",
          _id: "64a77a0ddc55e70524038e9f",
        },
        {
          title: "123",
          text: "123",
          files: [],
          createdAt: "2023-07-06T20:17:40.770Z",
          _id: "64a72164c661131412823664",
        },
      ],
      events: [],
      historyOfActions: [
        {
          text: "Escalated - Investigation",
          createdAt: "2023-07-07T02:40:36.269Z",
          _id: "64a77b2464bd9b2390aae4ba",
        },
        {
          text: "Escalated - Investigation",
          createdAt: "2023-07-07T02:38:25.564Z",
          _id: "64a77aa10a8a795d3aed95bc",
        },
        {
          text: "Escalated - Investigation",
          createdAt: "2023-07-07T02:38:14.073Z",
          _id: "64a77a964a027297a27575a0",
        },
        {
          text: "Note added to case by RANDY",
          createdAt: "2023-07-07T02:35:57.785Z",
          _id: "64a77a0ddc55e70524038ea0",
        },
        {
          text: "Note added to case by RANDY",
          createdAt: "2023-07-06T20:17:40.770Z",
          _id: "64a72164c661131412823665",
        },
        {
          text: "Case description updated",
          createdAt: "2023-07-06T20:17:28.073Z",
          _id: "64a72158001e4f90c6f48000",
        },
      ],
      createdAt: "2023-07-06T03:26:32.355Z",
      updatedAt: "2023-07-07T02:40:36.274Z",
      __v: 0,
      severity: "Level 3",
      caseOwner: "Unassigned",
      status: "Read",
      id: "64a634676ae9d058de3df78c",
    },


  ],
};
